import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../../providers/language_provider';
import { Button } from '../common/Button';

const ServiceCard = ({ title, description, image, buttonText, to, align = 'left' }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const cardVariants = {
    hidden: { opacity: 0, x: align === 'left' ? -50 : 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.div
      ref={ref}
      variants={cardVariants}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      className={`border rounded-md p-4 border-white/20 flex flex-col ${align === 'right' ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 items-center`}
    >
      <div className="flex-1 text-center md:text-left">
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">{title}</h3>
        <p className="text-gray-300 mb-6">{description}</p>
        <Button text={buttonText} to={to} variant="outline" />
      </div>
      <div className="flex-1">
        <img
          src={image}
          alt={title}
          className="rounded-lg shadow-xl w-full h-auto object-cover"
          style={{ maxHeight: '400px' }}
        />
      </div>
    </motion.div>
  );
};

export function Services() {
  const { content } = useLanguage();

  const services = [
    {
      title: content.serviceSection1,
      description: content.serviceContent1,
      buttonText: content.sectionButton1,
      to: '/pricing',
      image: require('../../assets/images/altavozReves2.webp'),
    },
    {
      title: content.serviceSection2,
      description: content.serviceContent2,
      buttonText: content.sectionButton2,
      to: '/services',
      image: require('../../assets/images/mezclaRev.webp'),
    },
    {
      title: content.serviceSection3,
      description: content.serviceContent3,
      buttonText: content.sectionButton3,
      to: '/catalogue',
      image: require('../../assets/images/instrus2.webp'),
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-24">
          {services.map((service, index) => (
            <ServiceCard
              key={service.title}
              {...service}
              align={index % 2 === 0 ? 'left' : 'right'}
            />
          ))}
        </div>
      </div>
    </section>
  );
}